import React from 'react';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import {
  PROCEDURE_TYPE,
} from '../../../configs';
import { getExistFields, setApplicant, setFields } from '../../../utils/utils';
import ApplicationsDTO from '../../../dto/ApplicationsDTO';
import CustomRegistryNumberSelector from '../../../components/fields/SelectInput/CustomRegistryNumberSelector';
import { MultipleRegistryNumberSelector } from '../../../components/fields/SelectInput/MultipleRegistryNumberSelector';

export function RegistryNumberInput(props) {
  const {
    control,
    numberHelperAction = () => {},
    setIsHidden = () => {},
    prefix = '',
    procedure,
    formMeta,
    isMultipleSelect,
    getValues = () => {},
    setValue = () => {},
    getFieldState = () => {},
    labelPrefix,
    title,
  } = props;
  const dto = new ApplicationsDTO();
  const attributes = dto.getAttributesByName();
  const dtoObject = (isMultipleSelect ? attributes.numbers : attributes.number);

  const onSelectNumber = selectedValue => {
    if (selectedValue === undefined || !selectedValue.length) {
      return;
    }
    const applicant = { ...selectedValue[0]?.applicant };

    const exitField = Object.keys(getExistFields(getValues('applicant')))?.filter(key => key !== 'isMatch');
    if (exitField?.length) {
      return;
    }
    // applicant: {
    // ...item,
    // ...getExistFields(isPartial ? getValues('applicant') : {}),
    // },
    setValue('applicant.isMatch', false);
    setApplicant(applicant, setValue);

    if ([PROCEDURE_TYPE.PROCEDURE_1227_2, PROCEDURE_TYPE.PROCEDURE_1227_4, PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_3].includes(procedure)) {
      if (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5) {
        const fields1 = [
          'carriage_contract_number',
          'carriage_contract_effective_date',
          'carriage_contract_expiration_date',
          'driver_license_series',
          'driver_license_number',
          'driver_license_issue_date',
          'driver_license_expiration_date',
        ];
        setFields(applicant, prefix, fields1, setValue);
      }
    }
    const fields2 = [
      'effective_date',
      'expiration_date',
    ];
    setFields(applicant, prefix, fields2, setValue);
    if (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3) {
      const fields3 = [
        'web_site',
        'software_names',
        'database_address',
        'server_address',
        'order_receiving_methods',
      ];
      setFields(applicant, prefix, fields3, setValue);
    }

    if (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8) {
      const fields4 = [
        'vehicle_brand',
        'vehicle_model',
        'vehicle_year',
        'vehicle_color',
        'vehicle_lpn',
        'vehicle_vin',
        'vehicle_registration_number',
        'vehicle_registration_issue_date',
        'ecology_class',
        'applicant_car_cd_file',
        'car_photo_file',
        'has_special_lifting_device',
        'ownership_contract_number',
        'ownership_type',
        'ownership_contract_effective_date',
        'ownership_contract_expiration_date',
        'ownership_contract_files',
      ];
      setFields(applicant, prefix, fields4, setValue);
    }
  };

  return (
    <FieldDTOWithCol
      control={control}
      formMeta={formMeta}
      type="text"
      title={title}
      labelPrefix={labelPrefix}
      setIsHidden={setIsHidden}
      component={isMultipleSelect ? MultipleRegistryNumberSelector : CustomRegistryNumberSelector}
      dtoObject={dtoObject}
      variant="material"
      isMultipleSelect={isMultipleSelect}
      withLabel
      loadAction={numberHelperAction}
      onSelectNumber={onSelectNumber}
      optionFormatter={item => ({ value: item.number, name: item.number })}
      getFieldState={getFieldState}
    />
  );
}
